export default __webpack_public_path__ + "static/media/contact1.e118693e.JPG";